import { render, staticRenderFns } from "./registrationData.vue?vue&type=template&id=0adaf128&scoped=true"
import script from "./registrationData.vue?vue&type=script&lang=js"
export * from "./registrationData.vue?vue&type=script&lang=js"
import style0 from "./registrationData.vue?vue&type=style&index=0&id=0adaf128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adaf128",
  null
  
)

export default component.exports